<template>
<div @focusout='hide' >
      <input class="ex-inputs-start" placeholder="From date" :value='formatDate(startDate)' @focus='show' @click='show' />
            -
      <input class="ex-inputs-end" placeholder="To date" :value='formatDate(endDate)' @focus='show' @click='show' />
      <div type="text" class='ex-inputs-picker'></div>

</div>
</template>

<script>
import {DateRangePicker} from 'tiny-date-picker/dist/date-range-picker';

export default {
    data() {
        return {
            datePicker: null,
            startDate: null,
            endDate: null,
            timeout: null
        }
    },
    methods: {
        show() {
            console.log('show');
            document.getElementsByClassName('ex-inputs-picker')[0].classList.add('ex-inputs-picker-visible');
        },
        hide() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(function() {
                if (!document.getElementsByClassName('ex-inputs-picker')[0].contains(document.activeElement)) {
                document.getElementsByClassName('ex-inputs-picker')[0].classList.remove('ex-inputs-picker-visible');
                }
            }, 10);
        },
        formatDate(date) {
            if (date) {
                return date.toDateString();
            }
        }
    },
    mounted() {
        this.datePicker = DateRangePicker(document.querySelector('.ex-inputs-picker'));
        this.datePicker.on('statechange', (_, picker) => { 
            var range = this.datePicker.state;
            this.startDate = range.start ? range.start : '';
            this.endDate = range.end ? range.end : '';

            if (range.start && range.end) {
                document.getElementsByClassName('ex-inputs-picker')[0].classList.remove('ex-inputs-picker-visible');
            }

            this.$emit('date-change', {dateFrom: this.startDate, dateTo: this.endDate});
        });
    }
}
</script>

<style lang="less">
@import url(../../node_modules/tiny-date-picker/tiny-date-picker.css);
@import url(../../node_modules/tiny-date-picker/date-range-picker.css);





.form-field {
  margin-bottom: 24px;
}

.form-field-label {
  display: block;
  margin-bottom: 4px;
}

.date-example {
  width: 100%;
  padding: 8px;
  border: 2px solid #DDD;
  border-radius: 4px;
}

.date-example:focus {
  border: 2px solid #0078CF;
}

.demo-content {
  text-align: center;
}

.form-group {
  text-align: left;
  display: inline-block;
  vertical-align: top;
  max-width: 400px;
  margin: 0 24px;
}

.code-sample {
  display: inline-block;
  font-family: monospace;
  background: #f5f5f5;
  padding: 4px;
  border: 1px solid #EEE;
}

@media (max-width: 480px), (max-height: 480px) {
  main {
    padding: 8px;
  }

  .form-group {
    width: 100%;
    max-width: 480px;
  }
}

/* Date Range Examples */

.date-range-examples {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
}

.ex-inputs {
  position: relative;
}

.ex-inputs-header {
  text-align: center;
  margin-bottom: 8px;
}

.ex-inputs-start,
.ex-inputs-end {
  padding: 8px;
  font-size: 1em;
  border: 1px solid #CCC;
  border-radius: 2px;
}

.ex-inputs-start:focus,
.ex-inputs-end:focus {
  border-color: #46A5F5;
}

.ex-inputs-picker {
  position: absolute;
  z-index: 1000;
  left: 50%;
 // top: calc(100% + 8px);
  opacity: 0;
  z-index: -20;
  transform: translateX(-50%);
  transition: all 0.25s;
}

.ex-inputs-picker-visible {
  opacity: 1;
  z-index: 1000;
}

@media (max-width: 616px), (max-height: 480px) {
  .ex-inputs-start,
  .ex-inputs-end {
    width: 100%;
  }
}
</style>
